// Centralized proxy configuration for serverless functions

function normalizeBase(base: string): string {
  return base.replace(/\/$/, '');
}

export function getProxyBase(): string {
  const functionsBase = (import.meta as any).env?.VITE_FUNCTIONS_BASE as string | undefined;
  const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL as string | undefined;

  if (typeof functionsBase === 'string' && functionsBase) {
    return normalizeBase(functionsBase);
  }

  if (typeof supabaseUrl === 'string' && supabaseUrl) {
    return normalizeBase(`${supabaseUrl}/functions/v1`);
  }

  // Fallback to Netlify functions on same origin
  if (typeof window !== 'undefined' && window.location?.origin) {
    return normalizeBase(`${window.location.origin}/.netlify/functions`);
  }

  // Final fallback (relative path)
  return '/.netlify/functions';
}

export function getProxyEndpoint(functionName = 'higherlevel-proxy'): string {
  return `${getProxyBase()}/${functionName}`;
}

export function getProxyHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  const base = getProxyBase();
  const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY as string | undefined;

  // If targeting Supabase Edge Functions, include anon key for auth/context when available
  if (base.includes('supabase.co') && typeof supabaseAnonKey === 'string' && supabaseAnonKey) {
    headers['Authorization'] = `Bearer ${supabaseAnonKey}`;
    headers['apikey'] = supabaseAnonKey;
  }

  return headers;
}


